import type { FieldType, ICollection, IQuotes, IQuoteScr, IScrLine } from '@/interfaces'
import { Collection, QuoteScr, ScrLine } from '@/models/'

export class Quotes implements IQuotes {
	[key: string]: FieldType
	id: number | string
	quoteId: number | string
	subjobId: number
	quoteStatus: string
	createDate: Date
	quoteLines: ICollection<IScrLine>
	quoteRev: number
	quoteState: number
	quoteStateAlias: string
	workOrderId: number
	createBy: number
	createByName: string
	quoteTotal: number
	scr: ICollection<IQuoteScr>

	constructor({
		quoteId,
		subjobId,
		quoteStatus,
		createDate,
		quoteLines,
		quoteRev,
		quoteState,
		quoteStateAlias,
		workOrderId,
		createBy,
		createByName,
		quoteTotal,
		scr
	}: IQuotes) {
		this.id = quoteId
		this.quoteId = quoteId
		this.subjobId = subjobId
		this.quoteStatus = quoteStatus
		this.createDate = createDate || new Date()
		this.quoteLines = new Collection(ScrLine, quoteLines)
		this.quoteRev = quoteRev
		this.quoteState = quoteState
		this.quoteStateAlias = quoteStateAlias
		this.workOrderId = workOrderId
		this.createBy = createBy
		this.createByName = createByName
		this.quoteTotal = quoteTotal
		this.scr = new Collection(QuoteScr, scr)
	}
}
